export default "/public/dist/img/territoriale.png";